// @flow

import * as React from 'react';

import { BubbleRatingWithReviewCount } from '@ta/styleguide.bubble-rating';
import classNames from '@ta/common.classnames';
import { featureIsEnabled } from '@ta/common.features';
import ObfuscatedLink from '@ta/common.obfuscated-link';
import { AttractionOffers } from '@ta/social.offers';
import { NoPhotoAvailableByPlaceType } from '@ta/social.place-type';
import { LocationSectionPhotoWrap } from '@ta/social.location-section';
import { InteractionLogger } from '@ta/tracking.interactions';
import { BookmarkIcon } from '@ta/trips.bookmark-icon';
import { QueriedTripFlowSelector } from '@ta/trips.trip-flow-selector';

import styles from './ShelfAttractionProductSection.less';

type Props = {
  /** The json location object */
  location: any,
};

const ShelfAttractionProductSection = (props: Props) => {
  const { location } = props;
  const hasPhotos = location && location.thumbnail && location.thumbnail;
  const locationUrl = location && location.route && location.route.url && location.route.url;

  // ML-4455 + TRVX-13935: Display prices on feed (Responsive web)
  const showAttractionPrices = featureIsEnabled('attraction_prices_in_shelves');

  // Attraction prices
  const displayPrice =
    location && location.displayPrice && location.displayPrice !== null && location.displayPrice;

  return (
    <InteractionLogger>
      {logInteraction => (
        <div className={styles.section}>
          <div
            className={classNames(styles.save_to_trip_cta, {
              [styles.heart]: featureIsEnabled('trips_saves_heart'),
            })}
          >
            <QueriedTripFlowSelector object={location}>
              {(openFlow, active) => (
                <BookmarkIcon
                  active={active}
                  bookmarkStyle="stacked"
                  onClick={e => {
                    logInteraction(e, 'save', { locationId: location.id });
                    openFlow();
                  }}
                />
              )}
            </QueriedTripFlowSelector>
          </div>
          <ObfuscatedLink
            encodedUrl={locationUrl}
            className="ui_poi_thumbnail"
            onClick={e => logInteraction(e, 'feedClick')}
          >
            {hasPhotos ? (
              <LocationSectionPhotoWrap
                location={location}
                geoShelfPhotoClassName={styles.shelfForPhoto}
              />
            ) : (
              <span className={styles.shelfForPhoto}>
                {' '}
                <NoPhotoAvailableByPlaceType location={location} />
              </span>
            )}
          </ObfuscatedLink>
          <ObfuscatedLink
            encodedUrl={locationUrl}
            className="item poi_name ui_link"
            onClick={e => logInteraction(e, 'feedClick')}
          >
            <span className={styles.name}>{location.name}</span>
          </ObfuscatedLink>
          {location.reviewSummary && location.reviewSummary.count !== 0 && (
            <ObfuscatedLink encodedUrl={locationUrl} onClick={e => logInteraction(e, 'feedClick')}>
              <span className="ui_shelf_poi_bubble_rating">
                <BubbleRatingWithReviewCount
                  numReviews={location.reviewSummary.count}
                  rating={location.reviewSummary.rating}
                  fontSize={12}
                />
              </span>
            </ObfuscatedLink>
          )}
          {/* Price display when available for a given location */}
          {showAttractionPrices && displayPrice ? (
            <AttractionOffers offer={displayPrice} locationUrl={locationUrl} />
          ) : (
            location.parent &&
            location.parent.name && (
              <div className={`${styles.subheader} ${styles.truncate}`}>{location.parent.name}</div>
            )
          )}
        </div>
      )}
    </InteractionLogger>
  );
};

export default ShelfAttractionProductSection;
